import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdClose,
  MdDelete,
  MdEdit,
  MdMail,
  MdPhone,
  MdSend,
  MdVisibility,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import { ExclamationCircleFilled } from "@ant-design/icons";
import api from "../../../services/api";
import {
  ViewInput,
  Table,
  Scroll,
  Message,
  InputTel,
  HeaderTitle,
} from "../../../GlobalStyles";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  Input,
  Pagination,
  Select,
  DatePicker,
  Spin,
  Space,
} from "antd";
import { FaWhatsapp } from "react-icons/fa";
import IntlCurrencyInput from "react-intl-currency-input";
import { addDays, format } from "date-fns";
import { Container, Card, ContainerLead, Label } from "./styles";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";

const { TextArea } = Input;
const { RangePicker } = DatePicker;

dayjs.extend(weekday);
dayjs.extend(localeData);

const { confirm } = Modal;

const Leads = () => {
  const navigate = useNavigate();

  const [leads, setLeads] = useState([]);
  const [leadsToSend, setLeadsToSend] = useState([]);
  const [userSend, setUserSend] = useState("");
  const [leadsSend, setLeadsSend] = useState([]);
  const [franqueadosAll, setFranqueadosAll] = useState([]);
  const [franqueadosLead, setFranqueadosLead] = useState([]);
  const [associadosAll, setAssociadosAll] = useState([]);
  const [associate_id, setAssociate_id] = useState("");
  const [lead, setLead] = useState({});
  const [leadsTotal, setLeadsTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [value, setValue] = useState(0);
  const [price, setPrice] = useState(0);
  const [page, setPage] = useState(0);
  const [id, setId] = useState("");
  const [dateStart, setDateStart] = useState(addDays(new Date(), -30));
  const [dateEnd, setDateEnd] = useState(new Date());
  const [multiLeads, setMultiLeads] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenLead, setIsOpenLead] = useState(false);
  const [isOpenSend, setIsOpenSend] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [observation, setObservation] = useState("");
  const [employees, setEmployees] = useState("");
  const [necessity, setNecessity] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [tag, setTag] = useState("");
  const [all, setAll] = useState(true);
  const [location, setLocation] = useState("");

  const currencyConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  useEffect(() => {
    loadLeads(page, all, tag, dateStart, dateEnd);
  }, [page, all, tag, dateStart, dateEnd]);

  useEffect(() => {
    loadLeadsAll();
    loadFranqueados();
    loadAssociados();
  }, []);

  async function loadAssociados() {
    await api
      .get(`/associates?all=true`)
      .then((response) => {
        setAssociadosAll(response.data.associates);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadFranqueados() {
    await api
      .get(`/users/franqueado?all=true`)
      .then((response) => {
        setFranqueadosAll(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadLeads(page, all, tag, dateStart, dateEnd) {
    await api
      .get(
        `/leads-send?page=${page}&tag=${tag}${
          !all ? `&dateStart=${dateStart}&dateEnd=${dateEnd}` : ""
        }`,
      )
      .then((response) => {
        setLeads(response.data.leads);
        setLeadsTotal(response.data.leadsTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function loadLeadsAll() {
    await api
      .get(`/leads-send?all=true`)
      .then((response) => {
        setLeadsToSend(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function createLead() {
    if (!name) {
      toast.warn("Preencha o nome para salvar lead");
    } else {
      if (email) {
        if (!IsEmail(email)) {
          toast.warn("Email inserido é inválido");
          return;
        }
      }
      if (phone_number) {
        if (!IsPhone(phone_number)) {
          toast.warn("Telefone inserido é inválido");
          return;
        }
      }
      if (id) {
        await api
          .put(`/lead/master/${id}`, {
            name: name,
            value: value,
            email: email,
            observation: observation,
            phone_number: phone_number,
            employees: employees,
            necessity: necessity,
            cnpj: cnpj,
            location: location,
            price: price,
            associate_id: associate_id,
          })
          .then((response) => {
            toast.success("Lead editado com sucesso");
            loadLeads(page, all, tag, dateStart, dateEnd);
            setIsOpen(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      } else {
        await api
          .post(`/lead/master`, {
            name: name,
            value: value,
            email: email,
            observation: observation,
            phone_number: phone_number,
            employees: employees,
            necessity: necessity,
            cnpj: cnpj,
            location: location,
            price: price,
            associate_id: associate_id,
          })
          .then((response) => {
            toast.success("Lead criado com sucesso");
            loadLeads(page, all, tag, dateStart, dateEnd);
            setIsOpen(false);
            loadLeadsAll();
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    }
  }

  async function sendLead() {
    if (!leads.length || !userSend) {
      toast.warn(
        leadsSend.length > 1
          ? "Selecione o franqueado e os leads para enviar"
          : "Selecione o franqueado e o lead para enviar",
      );
    } else {
      await api
        .put(`/lead/send`, {
          leads: multiLeads ? leadsSend : [id],
          userId: userSend,
        })
        .then((response) => {
          toast.success(
            `Lead${leadsSend.length > 1 && "s"} enviado com sucesso`,
          );
          loadLeads(page, all, tag, dateStart, dateEnd);
          setIsOpenSend(false);
          loadLeadsAll();
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    }
  }

  async function deleteLead(lead) {
    await api
      .delete(`/lead/master/${lead.id}`)
      .then((response) => {
        toast.success("Lead deletado com sucesso");
        loadLeads(page, all, tag, dateStart, dateEnd);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  function IsEmail(field) {
    const regx = /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i;
    return regx.test(field);
  }

  function IsPhone(field) {
    if (field.length >= 10) {
      return true;
    } else {
      return false;
    }
  }

  function getDate(date) {
    let fortmatDate = date.split("/");
    return new Date(fortmatDate[2], fortmatDate[1] - 1, fortmatDate[0]);
  }

  return (
    <Container>
      <HeaderTitle>
        <h1 style={{ flex: 1 }}>Leads Abertos</h1>
        <Space>
          <Button
            type="primary"
            style={{ borderRadius: 50 }}
            onClick={() => {
              setLeadsSend([]);
              setUserSend(null);
              setMultiLeads(true);
              setIsOpenSend(true);
            }}
          >
            <MdAdd size="20" color="#fff" />
            <span>Enviar Leads</span>
          </Button>
          <Button
            type="primary"
            style={{
              borderRadius: 50,
            }}
            onClick={() => {
              setName("");
              setEmail("");
              setObservation("");
              setEmployees("");
              setCnpj("");
              setNecessity("");
              setLocation("");
              setValue(0);
              setPrice(0);
              setPhone_number("");
              setId("");
              setAssociate_id(null);
              setIsOpen(true);
            }}
          >
            <MdAdd size="20" color="#fff" />
            <span>Novo Lead</span>
          </Button>
        </Space>
      </HeaderTitle>
      <Card>
        <p>Total</p>
        <CountUp duration={1} end={leadsTotal} separator="." />
      </Card>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <ViewInput style={{ width: "100%", maxWidth: 200, marginRight: 15 }}>
          <p>Visualizar</p>
          <Button
            style={{
              color: "#FFF",
              backgroundColor: all ? "#008037" : "#FFF",
              color: !all ? "#008037" : "#FFF",
              width: 80,
              alignSelf: "flex-end",
              marginBottom: 5,
              marginRight: 15,
              borderColor: "#008037",
              borderRadius: 50,
            }}
            onClick={() => {
              setAll(true);
            }}
          >
            Todos
          </Button>
          <Button
            style={{
              color: "#FFF",
              backgroundColor: !all ? "#008037" : "#FFF",
              color: all ? "#008037" : "#FFF",
              width: 105,
              alignSelf: "flex-end",
              marginBottom: 5,
              borderColor: "#008037",
              borderRadius: 50,
            }}
            onClick={() => {
              setAll(false);
            }}
          >
            Por Periodo
          </Button>
        </ViewInput>
        {all && (
          <ViewInput style={{ width: "100%", maxWidth: 280 }}>
            <p>Alterar Periodo de Cadastro</p>
            <RangePicker
              style={{ width: "100%" }}
              placeholder={["data inicial", "data final"]}
              value={[
                dateStart ? dayjs(dateStart) : "",
                dateEnd ? dayjs(dateEnd) : "",
              ]}
              format={"DD/MM/YYYY"}
              onChange={(value, dateString) => {
                setDateStart(getDate(dateString[0]));
                setDateEnd(getDate(dateString[1]));
                setPage(0);
              }}
              allowClear={false}
            />
          </ViewInput>
        )}

        <ViewInput style={{ width: 150, marginLeft: 15 }}>
          <p>Filtrar tag</p>
          <Select
            placeholder="selecionar associado"
            value={tag || null}
            showSearch
            optionFilterProp="children"
            style={{ width: "100%", textAlign: "left" }}
            onChange={(value) => {
              setTag(value);
            }}
          >
            {["ROI", "API", "Associado", "Cadastrado"].map((item) => {
              return <Select.Option value={item}>{item}</Select.Option>;
            })}
          </Select>
        </ViewInput>
      </div>
      {!isLoading && (
        <>
          {leads?.length ? (
            <>
              <Scroll>
                <Table>
                  <thead>
                    <tr>
                      <td>Nome</td>
                      <td>Tag</td>
                      <td>Email</td>
                      <td>Telefone</td>
                      <td>Franqueados</td>
                      <td>Cadastro</td>
                      <td style={{ width: 80 }}></td>
                    </tr>
                  </thead>
                  <tbody>
                    {leads.map((lead) => (
                      <tr key={lead.id}>
                        <td>{lead.name}</td>
                        <td>{lead.tag}</td>
                        <td>{lead.email || "Sem email"}</td>
                        <td>
                          {lead.phone_number.replace(
                            /(\d{2})(\d{5})(\d{4})/,
                            "($1) $2-$3",
                          ) || "Sem telefone"}
                        </td>
                        <td>
                          {lead.leads.length
                            ? lead.leads.length +
                              " franqueado" +
                              (lead.leads.length != 1 ? "s" : "")
                            : "Nenhum franqueado"}
                        </td>
                        <td>
                          {format(new Date(lead.create_at), "dd/MM/yyyy HH:mm")}
                        </td>
                        <td style={{ width: 120 }}>
                          <div
                            style={{
                              display: "flex",
                              cursor: "pointer",
                              alignItems: "center",
                              justifyContent: "flex-end",
                            }}
                          >
                            <MdVisibility
                              onClick={() => {
                                setLead(lead);
                                setIsOpenLead(true);
                              }}
                              style={{ cursor: "pointer" }}
                              size={18}
                              color={"#001B22"}
                            />
                            {!lead.is_user && !lead.leads.length && (
                              <MdSend
                                onClick={() => {
                                  setUserSend(null);
                                  setId(lead.id);
                                  setMultiLeads(false);
                                  setFranqueadosLead(lead.leads);
                                  setLeadsSend([]);
                                  setIsOpenSend(true);
                                }}
                                style={{ cursor: "pointer", marginLeft: 10 }}
                                size={16}
                                color={"#001B22"}
                              />
                            )}
                            <MdEdit
                              onClick={() => {
                                setId(lead.id);
                                setName(lead.name);
                                setEmail(lead.email);
                                setPhone_number(lead.phone_number);
                                setNecessity(lead.necessity);
                                setLocation(lead.location);
                                setEmployees(lead.employees);
                                setValue(lead.value);
                                setPrice(lead.price);
                                setCnpj(lead.cnpj);
                                setAssociate_id(lead.associate_id);
                                setObservation(lead.observation);
                                setIsOpen(true);
                              }}
                              style={{ cursor: "pointer", marginLeft: 10 }}
                              size={18}
                              color={"#001B22"}
                            />
                            <MdDelete
                              onClick={() => {
                                confirm({
                                  okText: "Confirmar",
                                  title: "Deseja excluir o Lead?",
                                  icon: <ExclamationCircleFilled />,
                                  content: `Após essa ação, o Lead ${lead.name} e todos leads duplicados também serão excluidos.`,
                                  onOk() {
                                    deleteLead(lead);
                                  },
                                  onCancel() {},
                                  cancelText: "Cancelar",
                                });
                              }}
                              style={{ cursor: "pointer", marginLeft: 6 }}
                              size={18}
                              color={"#001B22"}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Scroll>
              <Pagination
                style={{
                  margin: "25px 0",
                  alignSelf: "center",
                }}
                defaultCurrent={page + 1}
                onChange={(page) => {
                  setPage(page - 1);
                }}
                total={leadsTotal}
                pageSize={30}
                showTotal={(total) => `${total} leads`}
              />
            </>
          ) : (
            <Message>Nenhum lead encontrado</Message>
          )}
        </>
      )}

      {isLoading && <Spin size="large" style={{ marginTop: 50 }} />}

      <Modal
        title={id ? "Editando lead" : "Cadastrando um novo lead"}
        width={500}
        confirmLoading={isLoadingModal}
        open={isOpen}
        okText={id ? "Editar" : "Cadastrar"}
        cancelText="Cancelar"
        onOk={() => {
          createLead();
        }}
        onCancel={() => {
          setIsOpen(false);
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <ViewInput>
            <p>Nome*</p>
            <Input
              placeholder="nome"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Email*</p>
            <Input
              placeholder="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </ViewInput>
          <ViewInput className="input">
            <p>Telefone</p>
            <InputTel
              mask="(99) 99999-9999"
              maskChar=""
              noSpaceBetweenChars={true}
              value={phone_number}
              placeholder={"telefone"}
              style={{}}
              onChange={(text) => {
                setPhone_number(text.target.value.replace(/[^0-9]/g, ""));
              }}
            />
          </ViewInput>
          <ViewInput>
            <p>Necessidade</p>
            <Input
              placeholder="necessidade"
              value={necessity}
              onChange={(event) => setNecessity(event.target.value)}
            />
          </ViewInput>
          <ViewInput
            style={{
              width: "48%",
            }}
          >
            <p>Funcionários</p>
            <Input
              placeholder="funcionários"
              value={employees}
              onChange={(event) => setEmployees(event.target.value)}
            />
          </ViewInput>
          <ViewInput
            style={{
              width: "48%",
            }}
          >
            <p>Localização</p>
            <Input
              placeholder="localização"
              value={location}
              onChange={(event) => setLocation(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>CNPJ</p>
            <Input
              placeholder="cnpj"
              value={cnpj}
              onChange={(event) => setCnpj(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Observação</p>
            <TextArea
              style={{ minHeight: 60 }}
              placeholder="observação"
              value={observation}
              onChange={(event) => setObservation(event.target.value)}
            />
          </ViewInput>
          <ViewInput
            style={{
              width: "48%",
            }}
          >
            <p>Valor</p>
            <IntlCurrencyInput
              style={{
                width: "100%",
                backgroundColor: "#FFF",
                borderWidth: 0,
                color: "#000",
                padding: "6px 8px",
                fontSize: 14,
                borderWidth: 1,
                borderColor: "#ccc",
                borderStyle: "solid",
                borderRadius: 2,
                fontWeight: "400",
                paddingLeft: 12,
              }}
              currency="BRL"
              config={currencyConfig}
              value={value}
              onChange={(event, value) => setValue(value)}
            />
          </ViewInput>
          <ViewInput
            style={{
              width: "48%",
            }}
          >
            <p>Preço de Venda</p>
            <IntlCurrencyInput
              style={{
                width: "100%",
                backgroundColor: "#FFF",
                borderWidth: 0,
                color: "#000",
                padding: "6px 8px",
                fontSize: 14,
                borderWidth: 1,
                borderColor: "#ccc",
                borderStyle: "solid",
                borderRadius: 2,
                fontWeight: "400",
                paddingLeft: 12,
              }}
              currency="BRL"
              config={currencyConfig}
              value={price}
              onChange={(event, value) => setPrice(value)}
            />
          </ViewInput>
          <ViewInput style={{ width: "100%", marginTop: 5 }}>
            <p>Selecionar Associado</p>
            <Select
              placeholder="selecionar associado"
              value={associate_id || null}
              showSearch
              optionFilterProp="children"
              style={{ width: "100%", textAlign: "left" }}
              onChange={(value) => {
                setAssociate_id(value);
              }}
            >
              {associadosAll.map((item) => {
                return (
                  <Select.Option value={item.id}>{item.name}</Select.Option>
                );
              })}
            </Select>
          </ViewInput>
        </div>
      </Modal>

      <Modal
        title="Enviar Leads"
        width={500}
        confirmLoading={isLoadingModal}
        open={isOpenSend}
        okText={"Enviar"}
        cancelText="Cancelar"
        onOk={() => {
          sendLead();
        }}
        onCancel={() => {
          setIsOpenSend(false);
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginBottom: 25,
          }}
        >
          <ViewInput>
            <p>Selecione o Franqueado*</p>

            <Select
              placeholder="selecionar franqueado"
              value={userSend}
              showSearch
              optionFilterProp="children"
              style={{ width: "100%", textAlign: "left" }}
              onChange={(value) => {
                setUserSend(value);
              }}
            >
              {franqueadosAll
                .filter(
                  (item) =>
                    !franqueadosLead.some((data) => item.id === data.user_id),
                )
                .map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
            </Select>
          </ViewInput>
          {multiLeads && (
            <ViewInput>
              <p>Selecione os Leads*</p>
              <Select
                placeholder="selecionar franqueado"
                value={leadsSend}
                mode="multiple"
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setLeadsSend(value);
                }}
              >
                {leadsToSend.map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
          )}
        </div>
      </Modal>
      <Modal
        width={400}
        open={isOpenLead}
        onCancel={() => {
          setIsOpenLead(false);
        }}
        styles={{
          content: {
            padding: 0,
          },
        }}
        footer={<></>}
        closable={false}
      >
        <ContainerLead style={{ borderTopWidth: 30, margin: 0 }}>
          <MdClose
            style={{
              position: "absolute",
              cursor: "pointer",
              top: -25,
              right: 10,
            }}
            size={20}
            color="#3a3a3a"
            onClick={() => setIsOpenLead(false)}
          />
          <header style={{ top: -20 }}>
            <Label color={"#008037"} />
            <p>Lead</p>
          </header>
          <p style={{ width: "calc(100% - 50px)" }}>{lead.name}</p>
          {lead.email && (
            <p style={{ fontSize: 12, color: "#0009" }}>Email: {lead.email}</p>
          )}
          {lead.phone_number && (
            <p style={{ fontSize: 12, color: "#0009" }}>
              Telefone: {lead.phone_number}
            </p>
          )}
          {lead.necessity && (
            <p style={{ fontSize: 12, color: "#0009" }}>
              Necessidade: {lead.necessity}
            </p>
          )}
          {lead.employees && (
            <p style={{ fontSize: 12, color: "#0009" }}>
              Funcionarios: {lead.employees}
            </p>
          )}
          {lead.cnpj && (
            <p style={{ fontSize: 12, color: "#0009" }}>CNPJ: {lead.cnpj}</p>
          )}
          {lead.location && (
            <p style={{ fontSize: 12, color: "#0009" }}>
              Localização: {lead.location}
            </p>
          )}
          {lead.observation && (
            <p style={{ fontSize: 12, color: "#0009", width: "85%" }}>
              Observação: {lead.observation}
            </p>
          )}
          <p style={{ marginBottom: 5 }}>
            {(lead.value || 0).toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })}
          </p>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
            onClick={() => {}}
          >
            <div style={{ display: "flex" }}>
              {lead.phone_number && (
                <FaWhatsapp
                  onClick={() => {
                    window.open(
                      `https://api.whatsapp.com/send/?phone=55${lead.phone_number}`,
                    );
                  }}
                  size={18}
                  color={"#0c0"}
                  style={{ margin: "0 4px 0 0", cursor: "pointer" }}
                />
              )}

              {lead.phone_number && (
                <MdPhone
                  onClick={() => {
                    window.open(`tel:${lead.phone_number}`);
                  }}
                  size={18}
                  style={{ margin: "0 4px", cursor: "pointer" }}
                />
              )}

              {lead.email && (
                <MdMail
                  onClick={() => {
                    window.open(`mailto${lead.email}`);
                  }}
                  size={20}
                  color={"#FAB833"}
                  style={{ margin: "0 4px", cursor: "pointer" }}
                />
              )}
            </div>
          </div>
          {!!lead.leads?.length && (
            <p style={{ margin: "4px 0", fontSize: 13 }}>
              {lead.leads?.length} Franqueados
            </p>
          )}
          <div style={{ maxHeight: 200, overflowY: "scroll" }}>
            {lead.leads?.map((item, index) => {
              return (
                <div
                  style={{
                    borderBottom:
                      index + 1 != lead.leads?.length
                        ? "1px solid #ccc"
                        : "none",
                    paddingBottom: 5,
                    marginBottom: 5,
                    marginRight: 10,
                  }}
                >
                  <p style={{ fontSize: 13, color: "#000", fontWeight: 400 }}>
                    {item.user?.name}
                  </p>
                  <p style={{ fontSize: 12, color: "#000", fontWeight: 700 }}>
                    {item}
                  </p>
                  <p style={{ fontSize: 10, color: "#555", fontWeight: 400 }}>
                    {format(new Date(item.create_at), "dd/MM/yyyy HH:mm")}
                  </p>
                </div>
              );
            })}
          </div>
        </ContainerLead>
      </Modal>
    </Container>
  );
};

export default Leads;
